import {BaseAlert} from './Alerts';

/**
 * @deprecated Import from Alerts instead
 */
export const AlertModal = BaseAlert;
